import "./newLine.css"

import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import BaseButton from "../../../../components/BaseButton";
import BottomBar from "../../../../components/BottomBar";
import TitleBar from "../../../../components/TitleBar";
import { retrieveMe } from "../../../../sdk/apis";
import Inquiry from "../../../../sdk/containers/Inquiry";
import User from "../../../../sdk/containers/User";
import { createAccount, setCreateAccountErrorMsg, setErrorMsg, setValidateAccountSuccess, setValidateSuccess, submit } from "../../slice";
import { completionUrl, confirmUrl, inquiryUrl } from "../../urls";
import { usageClassificationList } from '../Inquiry/index'
import styles from './styles.module.css'


const Confirm = (props) => {
  const dispatch = useDispatch();

  const inquiry = useSelector((state) => state.inquiry.inquiry);
  const account = useSelector((state) => state.newAccount.accountInfo);
  const extendExpiration = useSelector((state) => state.inquiry.extendExpiration);

  const submitSuccess = useSelector((state) => state.inquiry.submitSuccess);
  const createAccountSuccess = useSelector((state) => state.newAccount.createSuccess);

  const [account_id, setAccount_id] = useState(null);
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    retrieveMe().then((result) => {
      setAccount_id(result.account_id);
      setUsername(result.name);
      setEmail(result.email);
    });
  }, []);

  const type = (new URL(document.location)).searchParams.get('type');
  // リロードすると入力画面に戻る
  if (JSON.stringify(account) === JSON.stringify(new User()) && JSON.stringify(inquiry) === JSON.stringify(new Inquiry())) {
    document.location = inquiryUrl(type);
  }

  let account_idForm = null;
  account_idForm = (<p className="form-control">{inquiry.account_id}</p>)
  if (account_id) {
    account_idForm = (
      <input name="username" type="text" className="form-control" value={account_id} disabled />
    );
  }
  let usernameForm = null;
  usernameForm = (<p className="form-control">{inquiry.username}</p>)
  if (username) {
    usernameForm = (
      <input name="username" type="text" className="form-control" value={username} disabled />
    );
  }
  let emailForm = null;
  emailForm = (<p className="form-control">{inquiry.email}</p>)
  if (email) {
    emailForm = (
      <input name="username" type="text" className="form-control" value={email} disabled />
    );
  }

  let submitButton = (
    <>
      <BaseButton onClick={() => {
        if (type === 'account') {
          dispatch(createAccount(account));
        } else {
          dispatch(submit(inquiry));
        }
      }}>
        送信
        <br />
        Send
      </BaseButton>
    </>
  );

  let title = null;
  let titleEn = null;
  let forms = null;
  let backToForm = null;
  let backToHome = null;
  if (type === 'account') {
    title = '新規アカウント申請　確認画面'
    titleEn = 'Application for a New Account, Confirmation Page';
    forms = (
      <>
        <div className={styles.item}>
          <label htmlFor="name" className="form-label">氏名 <small>※必須</small></label>
          <br />
          <label htmlFor="name">Name <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.name}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="furigana" className="form-label">氏名（フリガナ） <small>※必須</small></label>
          <br />
          <label htmlFor="name_f">Name (Alphabet) <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.name_f}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="email" className="form-label">Email <small>※必須</small></label>
          <br />
          <label htmlFor="email">Email <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.email}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="organization" className="form-label">所属機関 <small>※必須</small></label>
          <br />
          <label htmlFor="organization">Organization <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.organization}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="organization_f" className="form-label">所属機関（フリガナ） <small>※必須</small></label>
          <br />
          <label htmlFor="organization_f">Organization (furigana) <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.organization_f}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="department" className="form-label">所属部署 <small>※必須</small></label>
          <br />
          <label htmlFor="department">Department <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.department}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="department_f" className="form-label">所属部署（フリガナ） <small>※必須</small></label>
          <br />
          <label htmlFor="department_f">Department (furigana) <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.department_f}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="job_title" className="form-label">役職 <small>※必須</small></label>
          <br />
          <label htmlFor="job_title">Position <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.job_title}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="job_title_f" className="form-label">役職（フリガナ） <small>※必須</small></label>
          <br />
          <label htmlFor="job_title_f">Position（furigana） <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.job_title_f}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="address" className="form-label">住所 <small>※必須</small></label>
          <br />
          <label htmlFor="address">Address <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.address}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="tel" className="form-label">電話番号 <small>※必須</small></label>
          <br />
          <label htmlFor="tel">Telephone number<small><notice>※Required</notice></small></label>
          <p className="form-control">{account.tel}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="usage_classification" className="form-label">利用区分<small>※必須</small></label>
          <br />
          <label htmlFor="usageClassification">Division <small><notice>※Required</notice></small></label>
          <p className="form-control">{usageClassificationList[account.usage_classification]}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="purpose" className="form-label">利用目的<small>※必須</small></label>
          <br />
          <label htmlFor="purpose">Purpose <small><notice>※Required</notice></small></label>
          <p className="form-control">{account.purpose}</p>
        </div>
      </>
    );

  } else {
    if (extendExpiration) {
      title = 'アカウント有効期限延長　確認画面';
    } else {
      title = 'お問い合わせ　確認画面';
      titleEn = 'Inquiry, Confirmation Page';
    }
    forms = (
      <>
        <div className={styles.item}>
          <label htmlFor="account_id" className="form-label">ユーザーID  <small>※アカウント登録済みの方のみ必須</small></label>
          <br />
          <label htmlFor="account_id">User ID <small><notice>※required if you have</notice></small></label>
          {account_idForm}
        </div>
        <div className={styles.item}>
          <label htmlFor="username" className="form-label">氏名  <small>※必須</small></label>
          <br />
          <label htmlFor="username">User Name <small><notice>※required</notice></small></label>
          {usernameForm}
        </div>
        <div className={styles.item}>
          <label htmlFor="email" className="form-label">Email  <small>※必須</small></label>
          <br />
          <label htmlFor="email">Email address<small><notice>※required</notice></small></label>
          {emailForm}
        </div>
        <div className={styles.item}>
          <label htmlFor="subject" className="form-label">件名  <small>※必須</small></label>
          <br />
          <label htmlFor="subject">Mail Title <small><notice>※required</notice></small></label>
          <p className="form-control">{inquiry.subject}</p>
        </div>
        <div className={styles.item}>
          <label htmlFor="body" className="form-label">お問い合わせ内容  <small>※必須</small></label>
          <br />
          <label htmlFor="body">Inquiry Detail <small><notice>※required</notice></small></label>
          <p className="form-control">{inquiry.body}</p>
        </div>
      </>
    );
  }
  
  // useEffect(() => {
    //   // window.history.pushState(null, '', window.location.pathname);
    //   const onReload = (event) => {
      //     event.preventDefault();
      //     event.returnValue = '';
      //   };
      //   window.addEventListener('beforeunload', onReload);
      //   return () => {
        //     window.removeEventListener('beforeunload', onReload);
        //   };
        // }, []);
        
        if (submitSuccess && !createAccountSuccess) {
          document.location = completionUrl(type);
        } else if (!submitSuccess && createAccountSuccess) {
          document.location = completionUrl(type);
        } else {
          backToForm = (
            <>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <BaseButton variant='secondary' size="sm" onClick={() => {
          if (type === 'account') {
            dispatch(setValidateAccountSuccess(false));
            dispatch(setCreateAccountErrorMsg(new User()));
            props.history.push({
              pathname: inquiryUrl(),
              search: '?type=account',
              state: { account: account }
            });
          }
          else {
            dispatch(setValidateSuccess(false));
            dispatch(setErrorMsg(new Inquiry()));
            props.history.push({
              pathname: inquiryUrl(type),
              state: { inquiry: inquiry }
            });
          }
        }}>
          入力画面に戻る
          <br />
          Return to Previous Page
        </BaseButton>
      </>
    );
  }
  
  return (
    <>
      <TitleBar />
      <div className={styles.title}>
        {title}
        <br />
        {titleEn}
      </div>
      <div className={styles.inquiryform}>
        {forms}
        <div className={styles.item}>
          {submitButton}
          {backToForm}
          {backToHome}
        </div>
      </div>
      <div className="blank"></div>
      <BottomBar />
    </>
  )
}

export default Confirm;
